import script from "./DocumentInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentInput.vue?vue&type=script&setup=true&lang=js"

import "./DocumentInput.vue?vue&type=style&index=0&id=3871e232&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3871e232"]])

export default __exports__